import { ApiService } from './../services/api.service';
import { Oppinar } from './../class/oppinar';
import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  passoAtual = 'passo1';
  loja:any;
  escala:number = null;
  teste:number = 4;
  nome:string="";
  email:string="";
  telefone:string="";
  comentario:string="";
  select = null;
  selectLoja = null;
  cnpj = null;
  setSelect: any;
  group: any;
  groupSelecionado: any;
  stores: any;
  groupCode
  storeSelecionada: any;

  constructor(@Inject(DOCUMENT) private document: Document,public apiService:ApiService) { }

  ngOnInit() {
    this.getUrl()
  }

  getUrl(){
    let url = this.document.location.pathname.replace('/','')
    if(url.indexOf('group') > -1){
      this.groupCode = url.split('group/')
      this.groupCode = this.groupCode[1]
    }
    else{
      this.cnpj = this.document.location.pathname.replace('/','');
    }

    if(this.cnpj){
      this.apiService.getUrl(this.cnpj).subscribe((res)=>{
        this.loja = res;
      },
        error => {
          this.cnpj = null;
        }
      );
    }
    else if(this.groupCode){
      this.apiService.getRegion(this.groupCode).subscribe((res)=>{
        this.group = res
        if(this.group.length == 0){
          this.changeRegiao(null)
        }
      },
        error => {
          this.cnpj = null;
        }
      );
      console.log(this.group)
    }
    else{
      this.cnpj = null;
    }
  }

  changeStore(store){
    console.log(store)
    this.storeSelecionada = store;
  }

  disable(){
    let dogs = this.loja.themes.filter((themes) => {
      return themes.score == 0;
    })
    if(dogs.length == 0 && this.escala){
      return false
    }
    else {
      return true
    }
  }


  onChange(evento){
    this.setSelect= evento
  }

  changeRegiao(evento){

    if(evento){
      this.groupSelecionado = evento;
      this.apiService.getStores(this.groupCode,evento.name).subscribe((res)=>{
        this.stores = res
        console.log(this.stores)
      },
        error => {
          this.cnpj = null;
        }
      );
    }
    else{
      this.apiService.getStores(this.groupCode,null).subscribe((res)=>{
        this.stores = res
        console.log(this.stores)
      },
        error => {
          this.cnpj = null;
        }
      );
    }
  }


  onSubmit() {
    this.loja.client = this.nome;
    delete this.loja.sectors;
    delete this.loja._id;
    this.loja.sector = this.setSelect?this.setSelect.name:null;
    this.loja.recomendation = (this.escala-1);
    this.loja.comment = {
      email:this.email,
      phone:this.telefone,
      content:this.comentario,
    }
    this.apiService.postUrl(this.loja).subscribe((res)=>{
      this.passoAtual = 'passo4';
    });
  }


}


